import React from 'react';

import { IconButton, PopupMenu } from 'design-system-web';

import { useLabels } from '../../i18n/useLabels';
import type { QuestionRowViewModel } from '../../viewmodels/createQuestionRowViewModel';
import type { RowActionId } from '../../viewmodels/rowTypes';

type Props = {
  viewModel: Pick<QuestionRowViewModel, 'menuLabel' | 'menuEntries'>;
  onSelect: (entryId: RowActionId) => void;
};

export function QuestionActionsMenu({ viewModel, onSelect }: Props) {
  const { formatMessage } = useLabels();
  const menuLabel = formatMessage(viewModel.menuLabel);
  const items = viewModel.menuEntries.map(entry => ({
    label: formatMessage(entry.label),
    isDisabled: entry.isDisabled,
    tooltipText: entry.disabledReason
      ? formatMessage(entry.disabledReason)
      : undefined,
    onSelect: () => onSelect(entry.id),
  }));

  return (
    <PopupMenu
      placement="bottom-end"
      trigger={<IconButton icon="ellipsis-v" label={menuLabel} />}
      items={items}
    />
  );
}
